if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"webapp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(0946|1116|140|814)|8(138|332|883)0|(1645|3431|4781|5318|6388)0|17548|51354|62891|9097)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}